import { ReactElement } from 'react';

import styles from './CourtStep4AlertContent.module.scss';

interface iProps {
    formExpirationDate: string;
}

const CourtStep4AlertContent = ({ formExpirationDate }: iProps): ReactElement => (
  <p>
    Welcome back, we have filled out the application for you with saved information, please check the details before submitting.
    <br />
    <br />
    {formExpirationDate && (
      <>
        The information in this form will be saved until
        <span className={styles.bold}>
          {` ${formExpirationDate}. `}
        </span>
      </>
    )}
    {'Visit '}
    <a href="/Your-Fines/Your-Fines-List" className={`${styles.link} ${styles.bold}`}>Your fines</a>
    {' any time to delete a saved form or to manage notifications.'}
  </p>
);

export default CourtStep4AlertContent;
